import api from './api';

const vendorService = {
  listVendors: () => api.get('/vendors'),
  getVendor: (id) => api.get(`/vendors/${id}`),
  createVendor: (data) => api.post('/vendors', data),
  updateVendor: (id, data) => api.put(`/vendors/${id}`, data),
  deactivateVendor: (id) => api.delete(`/vendors/${id}`),

  addAccount: (vendorId, data) => api.post(`/vendors/${vendorId}/accounts`, data),
  updateAccount: (vendorId, accountId, data) => api.put(`/vendors/${vendorId}/accounts/${accountId}`, data),
  deleteAccount: (vendorId, accountId) => api.delete(`/vendors/${vendorId}/accounts/${accountId}`),
};

export default vendorService;
